import axios from "axios";
import { getCurrentClientId } from "../config/villageConfig";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://innermap.in/api",
  timeout: 10000, // 10 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

const SKIP_CLIENT_ID_PATHS = ["/logo-card-officers/"];

const shouldSkipClientId = (url = "") => {
  return SKIP_CLIENT_ID_PATHS.some((path) => url.includes(path));
};

// Add a request interceptor to automatically include clientId
axiosInstance.interceptors.request.use(
  (config) => {
    // Automatically add clientId based on current domain
    const clientId = getCurrentClientId();
    const skipClientId = shouldSkipClientId(config.url || "");
    
    // Add clientId to request params if not already present
    if (!skipClientId && config.method === 'get' && config.params) {
      config.params.clientId = config.params.clientId || clientId;
    } else if (!skipClientId && config.method === 'get') {
      config.params = { clientId, ...config.params };
    }
    
    // Add clientId to request body for POST/PUT requests if not already present
    if (['post', 'put', 'patch'].includes(config.method) && config.data) {
      if (typeof config.data === 'object' && !config.data.clientId) {
        config.data.clientId = clientId;
      }
    }
    
    // Example: Attach JWT token if available
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    console.log(`API Request for Village ClientId: ${clientId}`, config);
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor (optional)
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response) {
//       if (error.response.status === 401) {
//         console.warn("Unauthorized! Logging out...");
//         localStorage.removeItem("token");
//         window.location.href = "/login";
//       }
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
